import { HardCodedConfigService } from '@services/util/hard-coded-config.service';
import { inject, Injectable } from '@angular/core';
import { LocalStorageService } from './local-storage.service';

@Injectable({
  providedIn: 'root'
})
export class ConfirmableLookaheadStorageService {
  private readonly storageKey = 'confirmableLookaheadDays';
  private readonly localStorage = inject(LocalStorageService);
  private readonly config = inject(HardCodedConfigService);

  getDays(): number {
    const stored = this.localStorage.getItem(this.storageKey);
    const parsed = stored !== null ? parseInt(stored, 10) : NaN;
    if (Number.isNaN(parsed) || parsed < this.config.CONFIRMABLE_LOOKAHEAD_MIN_DAYS || parsed > this.config.CONFIRMABLE_LOOKAHEAD_MAX_DAYS) {
      return this.config.CONFIRMABLE_LOOKAHEAD_DEFAULT_DAYS;
    }
    return parsed;
  }

  setDays(days: number): void {
    this.localStorage.setItem(this.storageKey, String(days));
  }
}
